import { setCartPaymentQrCodePaymentSession, setCartPaymentQrCodePaymentSessionStarted, setCartPaymentTap2PayPaymentSession, setCartPaymentTap2PayRetryIsLoading, setCartPaymentTerminalPaymentSession, setProcessPaymentIsLoading } from '../../redux/action/cartPayment'
import { logger } from '../../logger/logger'

export const processPaymentMessageThunk = (message) => (dispatch, getState) => {
	switch (message?.type) {
		case 'payment.TERMINAL_PAYMENT_SESSION_PROCESS_REQUESTED':
			logger.info(`Terminal payment process requested: ${message.data?.sessionId} companyIndex=${getState().login.companyIndex}`)
			handleTerminalPaymentProcessing(message.data, dispatch, getState)
			break
		case 'payment.TERMINAL_PAYMENT_CARD_VALIDATION_SUCCEEDED':
			logger.info(`Terminal payment card validation succeeded: ${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleTerminalPaymentCardValidation(message.data, dispatch, getState)
			break
		case 'payment.TERMINAL_PAYMENT_SESSION_CAPTURED':
			logger.info(`Terminal payment session captured: ${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleTerminalPaymentCardValidation(message.data, dispatch, getState)
			break
		case 'payment.TERMINAL_PAYMENT_CARD_VALIDATION_FAILED':
			logger.info(`Terminal payment card validation failed: session=${message.data?.sessionId} code=${message.data?.failureCode} message=${message.data?.failureMessage} companyIndex=${getState().login.companyIndex}`)
			handleTerminalPaymentCardValidation(message.data, dispatch, getState)
			break
		case 'payment.TERMINAL_PAYMENT_SESSION_REFERRED_TO_ORDER':
			logger.info(`Terminal payment session referred to order: session=${message.data?.sessionId} orderId=${message.data?.paymentSession?.orderId} companyIndex=${getState().login.companyIndex}`)
			handleTerminalPaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.TERMINAL_PAYMENT_SESSION_CANCELED':
			logger.info(`Terminal payment session canceled: session=${message.data?.sessionId} orderId=${message.data?.paymentSession?.orderId} companyIndex=${getState().login.companyIndex}`)
			handleTerminalPaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.QR_PAYMENT_SESSION_CREDENTIALS_PROVIDED':
			logger.info(`QR payment session credentials provided: session=${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleQrCodePaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.QR_PAYMENT_SESSION_CAPTURED':
			logger.info(`QR payment session captured: session=${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleQrCodePaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.QR_PAYMENT_SESSION_CANCELED':
			logger.info(`QR payment session cancelled: session=${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleQrCodePaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.QR_PAYMENT_SESSION_REFERRED_TO_ORDER':
			logger.info(`QR payment session cancelled: session=${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleQrCodePaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.QR_PAYMENT_SESSION_STARTED':
			logger.info(`QR payment session started: session=${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			dispatch(setCartPaymentQrCodePaymentSessionStarted(true))
			break
		case 'payment.TAP2PAY_CARD_VALIDATION_SUCCEEDED':
			logger.info(`Terminal payment card validation succeeded: ${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleTap2PayPaymentCardValidation(message.data, dispatch, getState)
			break
		case 'payment.TAP2PAY_SESSION_REFERRED_TO_ORDER':
			logger.info(`Tap2Pay payment session referred to order: session=${message.data?.sessionId} orderId=${message.data?.paymentSession?.orderId}  clientSecret=${message.data?.paymentSession?.clientSecret} companyIndex=${getState().login.companyIndex}`)
			handleTap2PayPaymentSessionChanged(message.data, dispatch, getState)
			break
		case 'payment.TAP2PAY_SESSION_CAPTURED':
			logger.info(`Tap2Pay payment session captured: ${message.data?.sessionId} status=${message.data?.paymentSession?.status} companyIndex=${getState().login.companyIndex}`)
			handleTap2PayPaymentCardValidation(message.data, dispatch, getState)
			break
		case 'payment.TAP2PAY_CARD_VALIDATION_FAILED':
			logger.info(`Tap2Pay payment card validation failed: session=${message.data?.sessionId} code=${message.data?.failureCode} message=${message.data?.failureMessage} companyIndex=${getState().login.companyIndex}`)
			handleTap2PayPaymentCardValidation(message.data, dispatch, getState)
			break
		case 'payment.TAP2PAY_SESSION_CANCELED':
			logger.info(`Tap2Pay payment session canceled: session=${message.data?.sessionId} orderId=${message.data?.paymentSession?.orderId} companyIndex=${getState().login.companyIndex}`)
			handleTap2PayPaymentSessionChanged(message.data, dispatch, getState)
			break
		default:
			logger.warn('Unknown payment message type: ', JSON.stringify(message))
			break
	}
}

export const handleTerminalPaymentProcessing = (data, dispatch, getState) => {
	const terminalPaymentSession = getState().cartPayment.terminalPaymentSession
	if (terminalPaymentSession?.sessionId && terminalPaymentSession?.sessionId === data?.paymentSession?.sessionId) {
		logger.info(`Socket handleTerminalPaymentProcessing paymentSession=${data?.paymentSession?.sessionId}`)
		dispatch(setCartPaymentTerminalPaymentSession(data?.paymentSession))
	}
}

export const handleTerminalPaymentCardValidation = (data, dispatch, getState) => {
	const terminalPaymentSession = getState().cartPayment.terminalPaymentSession
	if (terminalPaymentSession?.sessionId && terminalPaymentSession?.sessionId === data?.paymentSession?.sessionId) {
		dispatch(setCartPaymentTerminalPaymentSession(data?.paymentSession))
		dispatch(setProcessPaymentIsLoading(false))
	}
}

export const handleTerminalPaymentSessionChanged = (data, dispatch, getState) => {
	const terminalPaymentSession = getState().cartPayment.terminalPaymentSession
	if (terminalPaymentSession?.sessionId && terminalPaymentSession?.sessionId === data?.paymentSession?.sessionId) {
		dispatch(setCartPaymentTerminalPaymentSession(data?.paymentSession))
	}
}

export const handleQrCodePaymentSessionChanged = (data, dispatch, getState) => {
	const qrCodePaymentSession = getState().cartPayment.qrCodePaymentSession
	if (qrCodePaymentSession?.sessionId && qrCodePaymentSession?.sessionId === data?.paymentSession?.sessionId) {
		dispatch(setCartPaymentQrCodePaymentSession(data?.paymentSession))
	}
}

export const handleTap2PayPaymentCardValidation = (data, dispatch, getState) => {
	const tap2PayPaymentSession = getState().cartPayment.tap2PayPaymentSession
	if (tap2PayPaymentSession?.sessionId && tap2PayPaymentSession?.sessionId === data?.paymentSession?.sessionId) {
		dispatch(setCartPaymentTap2PayRetryIsLoading(false))
		dispatch(setCartPaymentTap2PayPaymentSession(data?.paymentSession))
	}
}
export const handleTap2PayPaymentSessionChanged = (data, dispatch, getState) => {
	const tap2PayPaymentSession = getState().cartPayment.tap2PayPaymentSession
	if (tap2PayPaymentSession?.sessionId && tap2PayPaymentSession?.sessionId === data?.paymentSession?.sessionId) {
		dispatch(setCartPaymentTap2PayPaymentSession(data?.paymentSession))
	}
}
